import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=3dbf944c"
import script from "./ShareLink.vue?vue&type=script&lang=js"
export * from "./ShareLink.vue?vue&type=script&lang=js"
import style0 from "./ShareLink.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports